/* eslint-disable eqeqeq */
import { Buttons, Images, Tweens } from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import gameData from '../gameData';
import GameScreen from './GameScreen';
import { buttonTween, horizontalScreenTransisition } from './IntroScreen';

export default class LevelScreen extends Phaser.Scene {
  static get KEY() { return 'LevelScreen'; }

  create() {
    this.buttonInstances = [];
    this.background = Images.addImage(0, 0, 'level_background', this).setOrigin(0);
    this.selectedFrame = Images.addImage(0, 0, 'selected_BTN', this);
    this.title = Images.addImage(this.scale.width / 2, 512 - 440, 'TITLE_stages', this);

    let row = 0;
    let col = 0;
    let i = 0;

    for (const key in gameData.levels) {
      let xAdjust = 0;
      if (row == 2) {
        xAdjust = 185;
      }
      const name = gameData.levels[key].btnImage;
      const buttonCont = this.add.container((col * 185) + 106 + xAdjust, (row * 225) + 250);
      const button = Buttons.addButton(0, 0, name, name, 'menu_click', () => {
        this.levelButtonClicked(buttonCont);

      }, buttonCont);
      buttonCont.button = button;

      if (gameData.levels[key].isCompleted) {
        Images.addImage(50, 50, 'star', buttonCont);
        button.setTint(0x808080);
      }

      button.levelData = gameData.levels[key];

      const text = this.add.text((col * 185) + 106 + xAdjust, (row * 225) + 250 + 90, gameData.levels[key].name, { fontFamily: 'carton_sixregular', color: '#fff', fontSize: '20pt' }).setOrigin(.5, 0);

      col++;
      if (col == 4) {
        col = 0;
        row++;
      }

      const randChoiceX = Phaser.Math.Between(0, 2);
      const randChoiceY = Phaser.Math.Between(0, 2);
      let adjustX = 0;
      let adjustY = 0;

      if (randChoiceX == 0) {
        adjustX = 500;
      }
      else if (randChoiceX) {
        adjustX = -500;
      }

      if (randChoiceY == 0) {
        adjustY = 1000;
      }
      else if (randChoiceY) {
        adjustY = -1000;
      }

      const randChoice = Phaser.Math.Between(0, 1);

      if (randChoice == 0) {
        buttonCont.x += adjustX;
        adjustY = 0;
      }
      else {
        buttonCont.y += adjustY;
        adjustX = 0;
      }

      Tweens.addTween(buttonCont, 1000, { delay: i * 100, x: buttonCont.x - adjustX, y: buttonCont.y - adjustY }, Phaser.Math.Easing.Bounce.Out);

      buttonTween(buttonCont, 1.02, 900);
      this.buttonInstances.push(buttonCont);
      i++;
    }

    this.buttonInstances[0].add(this.selectedFrame);
    this.selected = this.buttonInstances[0];

    this.playButton = Buttons.addButton(this.scale.width / 2, this.scale.height - 100, 'BTN_play', 'BTN_play', 'click', () => {this.playButtonClicked();}, this);

    buttonTween(this.playButton, 1.03, 300);
  }

  levelButtonClicked(buttonCont) {
    this.selected.remove(this.selectedFrame, false);
    this.selected = buttonCont;
    buttonCont.add(this.selectedFrame);
  };

  playButtonClicked() {
    this.playButton.disableInteractive();

    gameData.currentLevel = this.selected.button.levelData;
    horizontalScreenTransisition(this, GameScreen.KEY);
  }
};